module.exports = __webpack_public_path__ + "static/media/file-upload-light.031e420b.svg";